module.exports = __webpack_public_path__ + "img/img-3.bb0f65d2.jpg";